export const formatAddress = (address) => {
  if (!address) return '';
  const { street, street2, city, state, zipcode } = address;
  const cityStateZipcode = [city, state, zipcode].filter(Boolean).join(' ');
  const addressParts = [street, street2, cityStateZipcode].filter(Boolean);
  return addressParts.join(', ');
};
